module.exports = "/fonts/vendor/@fontsource/inter/files/inter-greek-100-normal.woff2?9914692cec1b93ff80bfef68b8345803";